var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5293 35.5767C7.94596 35.5767 0.0292969 27.66 0.0292969 18.0767C0.0292969 8.49333 7.93252 0.57666 17.5159 0.57666C27.0992 0.57666 35.0293 8.49333 35.0293 18.0767C35.0293 27.66 27.1126 35.5767 17.5293 35.5767ZM15.3788 26.8669C15.8761 26.8669 16.3062 26.6384 16.6288 26.1411L25.661 11.9878C25.8626 11.6921 26.0374 11.3292 26.0374 11.0067C26.0374 10.2943 25.4056 9.85075 24.747 9.85075C24.3573 9.85075 23.9675 10.0792 23.6718 10.5362L15.3116 23.8292L10.8626 18.2513C10.5132 17.8077 10.1503 17.6464 9.72016 17.6464C9.06156 17.6464 8.51049 18.1706 8.51049 18.883C8.51049 19.219 8.6449 19.5819 8.87339 19.8642L14.0616 26.1545C14.4782 26.6653 14.8815 26.8669 15.3788 26.8669Z",
    fill: "#B6C700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSign);
export default __webpack_public_path__ + "static/media/tick_sign.35af9274aa9f866d9bef400cff9e02ef.svg";
export { ForwardRef as ReactComponent };